// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"017c20cb","281":"56e1d3d1","787":"2447b2c9","918":"621f9c77"}[chunkId] + ".chunk.js";
};